import React from 'react';
import { RenderModule } from 'holocron';
import PropTypes from 'prop-types';

const Nav = (props) => (
  <>
    <div data-testid="nav-container" id="rootNav">
      <div className="pad-2" />
      <div className="container pad-1-tb">
        <div id="dummy" className="module">
          <RenderModule moduleName="axp-global-rewards-nav" props={props} />
        </div>
      </div>
    </div>
    {/* <NavLinks /> */}
  </>
);

Nav.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.shape({
      props: PropTypes.shape({
        programType: PropTypes.string,
      }),
    }),
  }),
};

export default Nav;
